import React from 'react';

import IconFavorite from 'components/icons/favorite';
import IconSaved from 'components/icons/is-saved';

import { Button, Photo } from 'components';

import cx from 'classnames';
import styles from './styles.scss';

export default class AssignmentPhoto extends React.PureComponent {
  toggleFavorite = () => {
    const { orderId, currentSpread, photo } = this.props;
    this.props.toggleFavorite(orderId, currentSpread, photo.get('simpleId'));
  };

  toggleKeep = () => {
    const { orderId, photo } = this.props;
    this.props.toggleSaved(orderId, photo.get('simpleId'));
  };

  render() {
    const { className, photo, childBirthday, isSaved = false, isFavorite = false, isMonthSpread } = this.props;
    const { ratio } = photo.get('exif', {});
    const classes = cx(className || '', styles.photo, {
      [styles.selection]: photo.get('isSelection'),
      [styles.active]: isFavorite || isSaved,
    });

    const sizer = {
      paddingBottom: ratio * 100 + '%',
    };

    return (
      <div className={classes}>
        <div className={styles.inner} style={sizer}>
          <Photo
            className={styles.image}
            backgroundImage={true}
            photo={photo}
            callback={this.toggleFavorite}
            childBirthday={childBirthday}
            dateFormat={isMonthSpread ? 'MMMM YYYY' : null}
            showUseCount
          />
          <div className={styles.actions}>
            <Button
              className={cx(styles.action, styles.fav, {
                [styles.active]: isFavorite,
              })}
              fill={true}
              ripple={false}
              active={isFavorite}
              fillClass={styles.fill}
              onClick={this.toggleFavorite}>
              <IconFavorite />
            </Button>
            <Button
              className={cx(styles.action, styles.pin, {
                [styles.active]: isSaved,
              })}
              fill={true}
              ripple={false}
              active={isSaved}
              fillClass={styles.fill}
              onClick={this.toggleKeep}>
              <IconSaved />
            </Button>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/assignment-photo/index.js